if (!window.ProductGridSlider) {
  class ProductGridSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.product-grid-slider__track');
      this.slides = this.querySelectorAll('.product-grid-slider__item');
      this.prevButton = this.querySelector('.slider-button--prev');
      this.nextButton = this.querySelector('.slider-button--next');
      
      this.currentIndex = 0;
      this.itemsPerView = this.getItemsPerView();
      
      // ランダムシャッフルが有効な場合、初期化前にシャッフル
      if (this.dataset.enableShuffle === 'true') {
        this.shuffleSlides();
      }
      
      this.init();
    }

    init() {
      if (!this.slider || this.slides.length === 0) return;

      // ボタンイベント
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prev());
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.next());
      }

      // リサイズ対応
      window.addEventListener('resize', () => {
        this.itemsPerView = this.getItemsPerView();
        this.updateButtons();
      });

      // 初期状態のボタン更新
      this.updateButtons();

      // タッチイベント（SP用フリック）
      this.initTouchEvents();
    }

    getItemsPerView() {
      return window.innerWidth > 750 ? 5 : 2;
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.scrollToIndex(this.currentIndex);
      }
    }

    next() {
      const maxIndex = this.slides.length - this.itemsPerView;
      if (this.currentIndex < maxIndex) {
        this.currentIndex++;
        this.scrollToIndex(this.currentIndex);
      }
    }

    scrollToIndex(index) {
      const itemWidth = this.slides[0].offsetWidth;
      const gap = window.innerWidth > 750 ? 30 : 20;
      const scrollPosition = index * (itemWidth + gap);
      
      this.slider.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });

      this.updateButtons();
    }

    updateButtons() {
      if (!this.prevButton || !this.nextButton) return;

      const maxIndex = this.slides.length - this.itemsPerView;

      // 前へボタン
      if (this.currentIndex <= 0) {
        this.prevButton.setAttribute('disabled', '');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      // 次へボタン
      if (this.currentIndex >= maxIndex) {
        this.nextButton.setAttribute('disabled', '');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    shuffleSlides() {
      if (!this.slider || this.slides.length === 0) return;
      
      // スライドを配列に変換
      const slidesArray = Array.from(this.slides);
      
      // Fisher-Yatesシャッフルアルゴリズム
      for (let i = slidesArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [slidesArray[i], slidesArray[j]] = [slidesArray[j], slidesArray[i]];
      }
      
      // シャッフルした順序でDOMに再挿入
      slidesArray.forEach(slide => {
        this.slider.appendChild(slide);
      });
      
      // スライドの参照を更新
      this.slides = this.querySelectorAll('.product-grid-slider__item');
    }

    initTouchEvents() {
      let startX = 0;
      let scrollLeft = 0;
      let isDown = false;

      this.slider.addEventListener('touchstart', (e) => {
        isDown = true;
        startX = e.touches[0].pageX - this.slider.offsetLeft;
        scrollLeft = this.slider.scrollLeft;
      });

      this.slider.addEventListener('touchend', () => {
        isDown = false;
        // スクロール位置から現在のインデックスを計算
        const itemWidth = this.slides[0].offsetWidth;
        const gap = window.innerWidth > 750 ? 30 : 20;
        this.currentIndex = Math.round(this.slider.scrollLeft / (itemWidth + gap));
        this.updateButtons();
      });

      this.slider.addEventListener('touchmove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.touches[0].pageX - this.slider.offsetLeft;
        const walk = (x - startX) * 2;
        this.slider.scrollLeft = scrollLeft - walk;
      });
    }
  }

  window.ProductGridSlider = ProductGridSlider;

  if (!customElements.get('product-grid-slider')) {
    customElements.define('product-grid-slider', ProductGridSlider);
  }
}
